export default "__VITE_ASSET__b6911366__"